<template>
  <!-- 收藏统计 -->
  <div class="orderInterface">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['接口查询',$route.meta.title]">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-refresh" @click="updataInterface">更新接口</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exportData('hz')">导出汇总</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exportData('mx')">导出明细</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入关键字" v-model="searchForm.name"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderId"
        align="center"
        show-overflow-tooltip
        label="订单号">
      </el-table-column>
      <el-table-column
        prop="businessId"
        align="center"
        show-overflow-tooltip
        label="单位编号">
      </el-table-column>
      <el-table-column
        prop="businessName"
        align="center"
        show-overflow-tooltip
        label="单位名称">
      </el-table-column>
      <el-table-column
        prop="tel"
        align="center"
        show-overflow-tooltip
        label="联系人电话">
      </el-table-column>
      <el-table-column
        prop="userName"
        align="center"
        show-overflow-tooltip
        label="联系人">
      </el-table-column>
      <el-table-column
        prop="address"
        align="center"
        show-overflow-tooltip
        label="地址">
      </el-table-column>
      <el-table-column
        prop="date"
        align="center"
        show-overflow-tooltip
        label="日期">
      </el-table-column>
      <el-table-column
        prop="time"
        align="center"
        show-overflow-tooltip
        label="时间">
      </el-table-column>
      <el-table-column
        prop="rem"
        align="center"
        show-overflow-tooltip
        label="备注">
      </el-table-column>
      <!-- <el-table-column
        prop="disType"
        align="center"
        show-overflow-tooltip
        label="配送方式">
      </el-table-column> -->
      <el-table-column
        prop="payType"
        align="center"
        show-overflow-tooltip
        label="付款方式">
      </el-table-column>
      <el-table-column
        prop="isErp"
        align="center"
        show-overflow-tooltip
        label="是否下发">
      </el-table-column>
      <el-table-column
        prop="num"
        align="center"
        show-overflow-tooltip
        label="明细数">
      </el-table-column>
      <el-table-column
        label="操作"
        show-overflow-tooltip
        align="center">
        <template slot-scope="scope">
          <el-button type="primary" style="padding:2px 3px;" plain @click="handleInfo(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
  </div>
</template>

<script>

export default {
  name: 'orderInterface',
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        name: ''
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    }
  },
  mounted() {
    this.getTableData()
  },
  methods:{
    /**获取表格数据 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      let data = {
        type: "Int_order",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      }
      let proc = "Proc_Admin_GoodsList" // 存储过程名
      let type = "ReturnList"
      this.$requestSys({
        method: 'post',
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then(res => {
        this.tableData = []
        this.allPage = 0
        if(res.flag == 0){
          this.allPage = res.recordCount
          this.tableData = res.data.map(item => ({
            orderId: item.OrderNo, // 订单号
            businessId: item.BusinessID, // 单位编号
            businessName: item.businessname, // 单位名称
            tel: item.Telphone, // 联系人电话
            userName: item.AcceptName, // 联系人
            address: item.Address, // 地址
            date: item.Date, // 日期
            time: item.Time, // 时间
            rem: item.Remark, // 备注
            disType: item.psfs, // 配送方式
            payType: item.fhfs, // 付款方式
            isErp: item.Is_zx == 'Y' ? '是' : '否', // 是否下发
            num: item.number, // 明细数
          }))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**刷新数据 */
    handleRefresh(){
      this.getTableData()
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val
      this.getTableData()
    },
    updataInterface(){
      let data = {
        type: "Int_order_preform",
      }
      let proc = "Proc_Admin_GoodsList" // 存储过程名
      let type = "Perform"
      this.$requestSys({
        method: 'post',
        url: "order/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then(res => {
        if (res.flag == 0) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getTableData()
        } else {
          this.$message({
            message: res.Msg,
            type: 'error'
          })
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    exportData(type){
      let data = {
        type: type == 'hz' ? "Int_order" : 'Int_order_info_derived',
        userId: window.localStorage.getItem('userId'),
        entId: window.localStorage.getItem('entId'),
        strWhere: this.searchForm.name,
        PageIndex: 1,
        PageSize: 9999999,
      }
      let proc = "Proc_Admin_GoodsList" // 存储过程名
      window.location.href = this.baseUrl + "Order/NoPIGExprot?json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + encodeURIComponent(proc) + "&name=订单接口"
    },
    handleInfo(row){
      let prams = null
      if (row) {
        prams = encodeURIComponent(JSON.stringify({ id: row.orderId }))
      } else {
        prams = row
      }
      this.$router.push({
        path: "orderInterfaceInfo",
        query: {
          prams: prams,
        }
      })
      prams = null
    },
  }
}
</script>

<style scoped>
.orderInterface{
  width: 100%;
  height: 100%;
}
</style>
